<script>
import NotificationBubble from '@components/notifications/notification-bubble.vue';

export default {
  components: {
    NotificationBubble,
  },
  props: {
    recipe: {
      type: Object,
      required: true,
      default: () => {},
    },
    showCalories: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    gramsOfFat() {
      if (this.recipe && this.recipe.macroNutritionDigest) {
        return this.recipe.macroNutritionDigest.fat &&
          this.recipe.macroNutritionDigest.fat.value
          ? `${this.recipe.macroNutritionDigest.fat.value}g`
          : '0g';
      } else {
        return this.recipe && this.recipe.fatperserving !== null
          ? `${parseInt(this.recipe.fatperserving)}g`
          : '0g';
      }
    },
    gramsOfCarbs() {
      if (this.recipe && this.recipe.macroNutritionDigest) {
        return this.recipe.macroNutritionDigest.carbs &&
          this.recipe.macroNutritionDigest.carbs.value
          ? `${this.recipe.macroNutritionDigest.carbs.value}g`
          : '0g';
      } else {
        return this.recipe && this.recipe.fatperserving !== null
          ? `${parseInt(this.recipe.carbsperserving)}g`
          : '0g';
      }
    },
    gramsOfProtein() {
      if (this.recipe && this.recipe.macroNutritionDigest) {
        return this.recipe.macroNutritionDigest.protein &&
          this.recipe.macroNutritionDigest.protein.value
          ? `${this.recipe.macroNutritionDigest.protein.value}g`
          : '0g';
      } else {
        return this.recipe && this.recipe.fatperserving !== null
          ? `${parseInt(this.recipe.proteinperserving)}g`
          : '0g';
      }
    },
  },
};
</script>

<template>
  <div>
    <div class="calories-wrapper" v-if="showCalories">
      <label>Calories</label>
      <label>{{ recipe.calories }}</label>
    </div>
    <ul class="list-macros">
      <li>
        <NotificationBubble :minimal="true" />
        <span>Fat</span>
        <span>{{ gramsOfFat }}</span>
      </li>
      <li>
        <NotificationBubble :minimal="true" />
        <span>Carb</span>
        <span>{{ gramsOfCarbs }}</span>
      </li>
      <li>
        <NotificationBubble :minimal="true" />
        <span>Protein</span>
        <span>{{ gramsOfProtein }}</span>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.calories-wrapper {
  display: flex;
  justify-content: space-between;

  label {
    margin-bottom: 0;

    &:last-of-type {
      font-size: 1.8rem;
      font-weight: 800;
      letter-spacing: 0.1px;
      line-height: 2.2rem;
    }
  }
}

.list-macros {
  margin-top: 1.4rem;

  li {
    border-bottom: 1px solid $color-gray;
    display: flex;
    font-size: 1.2rem;
    font-weight: 600;
    justify-content: space-between;
    letter-spacing: -0.0571427px;
    line-height: 2.7rem;
    mix-blend-mode: normal;
    opacity: 0.7;
    padding: 0.3rem 1rem 0.3rem 2rem;
    position: relative;

    .notification-bubble {
      height: 1.1rem;
      left: 0;
      top: 1rem;
      width: 1.1rem;
    }

    &:first-child {
      .notification-bubble {
        background-color: $color-yellow;
      }
    }

    &:nth-child(2) {
      .notification-bubble {
        background-color: $color-neon-green;
      }
    }

    &:last-child {
      .notification-bubble {
        background-color: $color-primary-alt;
      }
    }
  }
}
</style>
